const InvitationConfig = {
  endpoints: {
    listGroupInvitations: "/invitations",
    listOwnInvitations: "/invitations/own",
    invite: "/invitations/new/",
    withdraw: "/invitations/withdraw/",
    decline: "/invitations/decline/",
    accept: "/invitations/accept/",
  },
  datafield: "invitations",
};

export default InvitationConfig;
